var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdxtfb-warp"},[_c('SvgPanZoom',{staticStyle:{"width":"100%","height":"100%"},attrs:{"zoomEnabled":true,"controlIconsEnabled":false,"fit":false,"center":false,"minZoom":0.5,"id":"svgbox"}},[_c('svg',{staticClass:"svgClass",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-water"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }